import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_async_linear_progress = _resolveComponent("async-linear-progress")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loader)
      ? (_openBlock(), _createBlock(_component_async_linear_progress, {
          key: 0,
          task: _ctx.task
        }, null, 8, ["task"]))
      : _createCommentVNode("", true),
    (_ctx.show)
      ? _renderSlot(_ctx.$slots, "default", { key: 1 })
      : _createCommentVNode("", true)
  ]))
}